module.exports = __webpack_public_path__ + "static/media/logo-login.fc23f30f.png";